var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "general-info" },
    [
      _c("section-title", {
        attrs: { "has-line": true, title: "Información General" }
      }),
      _c(
        "div",
        { staticClass: "bg-secondary-3 rounded pt-2 pb-3 px-4" },
        [
          _vm.readMode
            ? _c("div", [
                _c("div", { staticClass: "row bg-white p-3 rounded mb-2" }, [
                  _c("div", { staticClass: "col-12 col-md-3 mb-3" }, [
                    _vm._m(0),
                    _c("span", { staticClass: "general-info__info" }, [
                      _vm._v(" " + _vm._s(_vm.records.status.name) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "col-12 col-md-3 mb-3" }, [
                    _vm._m(1),
                    _c("span", { staticClass: "general-info__info" }, [
                      _vm._v(" " + _vm._s(_vm.records.monitoringNo) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "col-12 col-md-3 mb-3" }, [
                    _vm._m(2),
                    _c("span", { staticClass: "general-info__info" }, [
                      _vm._v(" " + _vm._s(_vm.records.createdByUser) + " ")
                    ])
                  ]),
                  _c("div", { staticClass: "col-12 col-md-3 mb-3" }, [
                    _vm._m(3),
                    _c("span", { staticClass: "general-info__info" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("date")(_vm.records.findingDate)) +
                          " "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "col-12 col-md-4 mb-3" }, [
                    _vm._m(4),
                    _c("span", { staticClass: "general-info__info" }, [
                      _vm._v(" " + _vm._s(_vm.records.reason.name) + " ")
                    ])
                  ])
                ]),
                _c("div", { staticClass: "row p-3 rounded mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 mt-md-3" },
                    [
                      _c("custom-text-area", {
                        attrs: {
                          id: "comment",
                          disabled: _vm.readMode,
                          label: "Comentario:",
                          maxlength: 500,
                          name: "comment",
                          rows: 3,
                          "show-char-count": false
                        },
                        on: { input: _vm.onCommentChange },
                        model: {
                          value: _vm.records.comment,
                          callback: function($$v) {
                            _vm.$set(_vm.records, "comment", $$v)
                          },
                          expression: "records.comment"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          !_vm.readMode
            ? _c(
                "validation-observer",
                { ref: "umesrDetailsFormGeneralInfo", attrs: { tag: "form" } },
                [
                  _c("div", { staticClass: "row bg-white p-3 rounded mb-2" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-date-picker", {
                                      staticClass: "w-100",
                                      attrs: {
                                        "class-container": "",
                                        "custom-error-msg":
                                          "Favor seleccionar fecha.",
                                        disabled: _vm.readMode,
                                        error: errors[0],
                                        label: "Fecha de Hallazgo:",
                                        "max-date": new Date(),
                                        placeholder: "DD/MM/YYYY"
                                      },
                                      on: {
                                        onSelectedDate: _vm.onSelectedDate
                                      },
                                      model: {
                                        value: _vm.records.findingDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.records,
                                            "findingDate",
                                            $$v
                                          )
                                        },
                                        expression: "records.findingDate"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1462894594
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-5" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        "custom-error-msg":
                                          "Favor seleccionar el tipo de hallazgo.",
                                        disabled: _vm.readMode,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        label: "Tipo de Hallazgo:",
                                        options: _vm.reasons,
                                        placeholder: "Seleccione",
                                        value: _vm.records.reasonId
                                      },
                                      on: { input: _vm.onActivityChange },
                                      model: {
                                        value: _vm.records.reason,
                                        callback: function($$v) {
                                          _vm.$set(_vm.records, "reason", $$v)
                                        },
                                        expression: "records.reason"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3602670918
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 mt-md-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-text-area", {
                                      attrs: {
                                        id: "comment",
                                        "custom-error-msg":
                                          "Favor escriba un comentario.",
                                        disabled: _vm.readMode,
                                        error: errors[0],
                                        label: "Comentario:",
                                        maxlength: 500,
                                        name: "comment",
                                        rows: 3,
                                        "show-char-count": true
                                      },
                                      on: { input: _vm.onCommentChange },
                                      model: {
                                        value: _vm.records.comment,
                                        callback: function($$v) {
                                          _vm.$set(_vm.records, "comment", $$v)
                                        },
                                        expression: "records.comment"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            313629576
                          )
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "general-info__label" }, [
      _c("em", {
        staticClass: "general-info__label_icon fas fa-ballot-check text-orange"
      }),
      _vm._v(" Estatus: ")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "general-info__label" }, [
      _c("em", {
        staticClass: "general-info__label_icon fas fa-ballot-check text-orange"
      }),
      _vm._v(" Número de Hallazgo: ")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "general-info__label" }, [
      _c("em", {
        staticClass: "general-info__label_icon fas fa-ballot-check text-orange"
      }),
      _vm._v(" Creado por: ")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "general-info__label" }, [
      _c("em", {
        staticClass: "general-info__label_icon fa fa-calendar text-orange"
      }),
      _vm._v(" Fecha: ")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "general-info__label" }, [
      _c("em", {
        staticClass: "general-info__label_icon fas fa-ballot-check text-orange"
      }),
      _vm._v(" Hallazgo: ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }